import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import OrderTracking from './pages/OrderTracking'
import DistributionMaps from './pages/DistributionMaps'
import Reports from './pages/Reports'
import Analytics from './pages/Analytics'
import DataImport from './pages/DataImport'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<OrderTracking />} />
          <Route path="maps" element={<DistributionMaps />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="data-import" element={<DataImport />} />
          <Route path="reports" element={<Reports />} />
        </Route>
      </Routes>
    </AuthProvider>
  )
}

export default App
